import { firebase } from "../helpers/firebase";

const firestore = firebase.firestore();
const collection = "colegios";
const stateOneName = `${collection}_sel`;
const loadedName = `${collection}_load`;
const stateListName = `${collection}_list`;

const objectConst = {};
objectConst[stateListName] = [];
objectConst[stateOneName] = null;
objectConst[loadedName] = false;

let state = objectConst;

let actions = {
  cleanAllColegio({ commit }) {
    commit("setState", { key: stateOneName, value: null });
    commit("setState", { key: stateListName, value: [] });
    commit("setState", { key: loadedName, value: false });
  },

  setOneColegio({ commit, state }, id) {
    if (state.user) {
      const finded = state[stateListName].find(sn => sn.id === id);
      if (finded) commit("setState", { key: stateOneName, value: finded });
      return;
    }
    return Promise.reject(
      new Error("User is not logged for set action", collection)
    );
  },

  listColegio({ commit, state }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .get()
        .then(querysnap => {
          commit("setState", { key: loadedName, value: false });
          const results = [];
          querysnap.forEach(doc => results.push({ id: doc.id, ...doc.data() }));
          commit("setState", { key: stateListName, value: results });
        })
        .catch(err => {
          commit("setState", { key: loadedName, value: false });
          throw err;
        });
    }
    return Promise.reject(
      new Error("User is not logged for list action", collection)
    );
  },

  storeColegio({ commit, state }, { data }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .add(data)
        .then(docRef => {
          commit("setState", { key: loadedName, value: false });
          commit("setState", {
            key: stateListName,
            value: [...state[stateListName], { id: docRef.id, ...data }]
          });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for store action", collection)
    );
  },

  updateColegio({ commit, state }, { id, data }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .doc(id)
        .update(data)
        .then(() => {
          commit("setState", { key: loadedName, value: false });
          const stateCopy = state[stateListName];
          for (let i = 0; i < stateCopy.length; i++) {
            if (stateCopy[i].id === id)
              stateCopy[i] = Object.assign({}, stateCopy[i], data);
          }
          commit("setState", { key: stateListName, value: stateCopy });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for update action", collection)
    );
  },

  removeColegio({ commit, state }, { id }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .doc(id)
        .delete()
        .then(() => {
          commit("setState", { key: loadedName, value: false });
          const stateCopy = state[stateListName];
          const index = stateCopy.findIndex(st => st.id === id);
          if (index > -1) stateCopy.splice(index, 1);
          commit("setState", { key: stateListName, value: stateCopy });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for remove action", collection)
    );
  }
};

export default {
  state,
  actions,
  names: {
    collection,
    sel: stateOneName,
    list: stateListName,
    load: loadedName
  }
};
